<template>
  <li class="total-item mb-1">
    <div class="row">
      <div class="col-md-6 col-xs-12">
        <div>
          <samp class="name">{{ data.productName }}</samp>
        </div>
      </div>
      <div class="col-md-2 col-xs-12">
        <div class="bg-light">
          <samp class="d-sm-none">Precio: </samp>
          <samp class="price">{{ data.productPrice }} €</samp>
        </div>
      </div>
      <div class="col-md-2 col-xs-12">
        <div>
          <samp class="qtty">{{ data.deliveredQuantity }} ud.</samp>
        </div>
      </div>
      <div class="col-md-2 col-xs-12">
        <div class="bg-light">
          <samp class="d-sm-none">Total:: </samp>
          <samp>{{ finalPrice }} €</samp>
        </div>
      </div>
    </div>
    <hr>
  </li>
</template>

<script>
export default {
  name: 'ProductPriceQtty',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    finalPrice () {
      return this.data.productPrice * this.data.deliveredQuantity
    }
  }
}
</script>

<style lang="stylus" scoped>
.total-item
  .name
    font-weight bold

</style>
